import { IconButton } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { MinimizeIcon } from '@/shared/icons/Icons';

type Props = {
  className?: string;
  onClick: () => void;
};

// The minimize affordance shown in a modal's header; shared by the modal
// primitives (KpcModal, FormModal) so their styling can't drift apart.
const MinimizeButton: React.FC<Props> = ({ className, onClick }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      aria-label={t('minimize')}
      className={classNames('absolute top-2 z-10', className)}
      color="neutral"
      size="sm"
      variant="plain"
      onClick={onClick}
    >
      <MinimizeIcon />
    </IconButton>
  );
};

export default MinimizeButton;
